var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#D8E7FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 14.3333V17.6667C7.6665 19.3333 8.49984 20.1667 10.1665 20.1667H11.3582C11.6665 20.1667 11.9748 20.2583 12.2415 20.4167L14.6748 21.9417C16.7748 23.2583 18.4998 22.3 18.4998 19.825V12.175C18.4998 9.69165 16.7748 8.74165 14.6748 10.0583L12.2415 11.5833C11.9748 11.7417 11.6665 11.8333 11.3582 11.8333H10.1665C8.49984 11.8333 7.6665 12.6667 7.6665 14.3333Z",
    fill: "#0A49A5",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.6666C22.4833 14.6416 22.4833 17.3583 21 19.3333",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5249 10.5834C24.9332 13.7917 24.9332 18.2084 22.5249 21.4167",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.3aa349f4df43034ab8a8d8b6facabac9.svg";
export { ForwardRef as ReactComponent };